<template>
  <div class="content" >
    <WebHeader menu='6' ></WebHeader>
    <div class="web-page">
      <div class="imgdiv">
        <img src="static/img/activityInformation/banner.jpg">
      </div>
      <div class="block-title">
        <div></div>
        <div>活动信息</div>
        <div></div>
      </div>
      <div class="filter-block">
        <div class="van-filter">
<!--          <div :style="[{'border-left':index==0 ?'2px solid #640acd':''},{'border-radius':yearList[(yearList.length-1)]==item ?'0px 8px 8px 0px':''},{'border-radius':yearList[0]==item ?'8px 0px 0px 8px':''}] " :class="electionYear==item?'sel':''" @click="setYear(item)"-->
<!--               v-for="(item,index) in yearList" >{{item}}</div>-->
          <div :style="[{'border-left':index==0 ?'2px solid rgb(100,0,160)':''},{'border-radius':borderStyle(index)}] " :class="electionYear==item?'sel':''" @click="setYear(item)"
               v-for="(item,index) in yearList" :key="index">{{item}}</div>
        </div>
      </div>
      <!-- 内容 -->
      <div class="contentPart" :class="dataList.length%3==1?'contentPartTwo':'contentPartOne'">
        <div class="piece" v-for="(item,index) in dataList" :key="index">
          <img style="border-radius: 8px 8px 0 0;" :src="getImgUrl(item.picturePath)">
          <div class="pieceP1" @click="toLink(item.httpUrl)" :title="item.title"><a>{{item.title}}</a></div>
<!--          <p class="pieceP1">{{item.title}}</p>-->
          <div class="pieceP2" @click="toLink(item.httpUrl)" :title="item.content"><a>{{item.details}}</a></div>
<!--          <p @click="hideContent" :id="item.id" class="pieceP2">{{item.content}}</p>-->
<!--          <el-button>-->
<!--            <div class="buttonUnderline">查看更多</div>-->
<!--          </el-button>-->
        </div>
      </div>

      <div class="replenish"></div>
    </div>
    <top-button></top-button>
    <WebFooter></WebFooter>
  </div>
</template>
<script>
  import { getList } from "@/api/product";
  import TopButton from "../../components/web/topButton";
    export default {
        name: "ActivityInformation",
      components: {TopButton},
      data() {
        return {
          dataList:[
            // {
            // id: 'content1',
            // httpUrl: 'https://mp.weixin.qq.com/s/iBelnWx8LoFbHy6mC7YhQg',
            // picturePath: require('../../../static/img/activityInformation/1.png'),
            // title:'BMLP招聘 | GE医疗走进中欧国际工商学院',
            // details: '11月21日，GE医疗走进了中欧国际工商学院，参与“智荟中欧高层管理论坛”。在论坛中，来自GE医疗的各位高管围绕“Creating a New Era of Care”为主题发表讲话并参与圆桌讨论。'
            // },
            // {
            //   id: 'content2',
            //   httpUrl: 'https://mp.weixin.qq.com/s/SxiyU88iv9r0gtgb88ptHA',
            //   picturePath: require('../../../static/img/activityInformation/2.png'),
            //   title:'喜报 | GE医疗再度荣膺卓越雇主',
            //   details: '坚定地相信全面国产、数字赋能、合作共赢，致力于培养有速度、有担当、接地气、有企业家精神的中国人才，GE医疗荣膺T+Employer大健康卓越雇主2022。这是GE医疗第二次获得T+Employer大健康卓越雇主的奖项。'
            // },
            // {
            //   id: 'content3',
            //   httpUrl: 'https://mp.weixin.qq.com/s/7pCt8M3cBfqjHlxkM3MTuQ',
            //   picturePath: require('../../../static/img/activityInformation/3.png'),
            //   title:'GE医疗2023秋招空中宣讲会19点上线，今晚等你云端相见！',
            //   details: 'GE医疗2023秋招空中宣讲会将于11月1日19点准时上线。GE医疗中国总裁以前沿视角介绍企业，以战略高度分享发展。GE医疗中国HR负责人解读培养方案，寄托无限期许，大咖助力职达梦想。'
            // },
            // {
            //   id: 'content4',
            //   httpUrl: 'https://mp.weixin.qq.com/s/7TGdWcsFu_GbFeVVYEv9ig',
            //   picturePath: require('../../../static/img/activityInformation/4.png'),
            //   title:'G往开来，E路有你 | GE医疗 2023秋季校园招聘正式启动！',
            //   details: '9月15日，GE医疗 2023秋季校园招聘正式启动，全面网申正式开启，4大管培生项目等你来投递！领航未来，即刻启程，G往开来，E路有你，GE医疗期待与你共同解锁闪耀未来！'
            // },
            // {
            //   id: 'content5',
            //   httpUrl: 'https://mp.weixin.qq.com/s/l9KDZIiwz7bwlnyjxaOFYw',
            //   picturePath: require('../../../static/img/activityInformation/tu5.png'),
            //   title:'万千热爱，初心未改丨GE精益绿色挑战赛感恩今夏有你',
            //   details: '为推进青年发展和绿色环保活动，更好地引导青年关注环保话题，仲夏之际，GE 联合益优青年中心对真实生产问题推出 GE 精益绿色挑战赛第二季，2022 年 9 月 29 日，活动迎来终章，至此长达两个月的赛事取得圆满成功。'
            // },
            // {
            //   id: 'content6',
            //   httpUrl: 'https://mp.weixin.qq.com/s/clqU6GFkcgbeAKXSxHLA7w',
            //   picturePath: require('../../../static/img/activityInformation/tu6.png'),
            //   title:'GE医疗夏日限定EID茶话会精彩放送！',
            //   details: '八月初始，遇见美好，GE医疗夏日限定EID茶话会开启。你画我猜笑声不断，热力舞动点燃全场，精彩辩论全程高能，更有EID们吐露心声，真诚交谈。一次美好趣味的活动，一群乐观幽默的EID，一场平等真诚的对话，茶话会精彩放送不容错过！'
            // }
          ],
          yearList:[],
          electionYear:null,
          queryParams: {
            pageNum: 1,
            pageSize: 20,
            httpType: 'huodong',
            year: null
          }
        }
      },
      created() {
        getList(this.queryParams).then(response => {
          console.log(response.data.rows);
          this.yearList = (response.data.rows)[0].params.yearList;
          this.electionYear=this.yearList[0];
          this.dataList=response.data.rows;
        });
      },
      methods: {
        getList(){
          getList(this.queryParams).then(response => {
            console.log(response.data.rows);
            this.dataList=response.data.rows;
          });
        },
        getImgUrl(value){
          return this.global.apiHttpUrl+value;
        },
        setYear(e){
          this.electionYear=e;
          this.queryParams.year=e;
          this.getList();
        },
        borderStyle(index){
          if(this.yearList.length===1){
            return '8px 8px 8px 8px'
          }else if(index==0){
            return '8px 0px 0px 8px'
          } else if(index==this.yearList.length-1){
            return '0px 8px 8px 0px'
          }
        },
        toLink(link){
          window.open(link,'_blank');
        }
      }
    }
</script>

<style scoped>
  .block-title {
    padding-top: 50px;
    padding-bottom: 45px;
  }
  /*年份开始*/
 /* .filter-block{
    margin: 0 auto 37px;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }*/
  .van-filter .sel {
    background-color: rgb(100,0,160);
    color: #ffffff;
  }
 /* .filter-block .van-filter{
    display: flex;
    margin: auto;
    cursor:pointer;
  }*/
/*  .van-filter > div{
    width: 48px;
    height: 38px;
    font-size: 22px;
    color: rgb(100,0,160);
    border-top: 2px solid rgb(100,0,160);
    border-right: 2px solid rgb(100,0,160);
    border-bottom: 2px solid rgb(100,0,160);
    border-radius: 0px;
    line-height: 42px;
    padding: 8px 30px;
  }*/
  .filter-block{
    margin: 0 auto 37px;
    display: flex;
    display: -webkit-flex;
    align-items: center;
    -webkit-align-items:center;
    justify-content:center;
    -webkit-justify-content: center;
  }
  .filter-block .van-filter{
    display: flex;
    display: -webkit-flex;
    justify-content: center;
    -webkit-justify-content: center;
    align-items: center;
    -webkit-align-items:center;
    cursor:pointer;
  }

  .van-filter > div{
   /* width: 53px;
    height: 17px;*/
    width: 108px;
    height: 54px;
    font-size: 22px;
    color: rgb(100,0,160);
    border-top: 2px solid rgb(100,0,160);
    border-right: 2px solid rgb(100,0,160);
    border-bottom: 2px solid rgb(100,0,160);
    border-radius: 0px;
    line-height: 38px;
    display: flex;
    display: -webkit-flex;
    align-items: center;
    -webkit-align-items:center;
    justify-content: center;
    -webkit-justify-content: center;
  }
  /*年份结束*/

  .imgdiv{
    display: flex;
    display: -webkit-flex;
    justify-content: center;
    -webkit-justify-content: center;
    align-items: center;
    -webkit-align-items:center;
  }
  .imgdiv img{
    width: 100%;
  }
  /*内容*/
  .contentPart{
    margin: 0 auto;
    display: flex;
    flex-wrap: wrap;
    max-width: 1230px;
    justify-content: center;


    border-radius: 8px;
  }
  .contentPartOne::after{
    content: "";
    width: 380px;
    margin: 15px 15px;
  }
  .contentPartTwo::after{
    content: "";
    width: 790px;
    margin: 15px 15px;
  }
  .piece{
    position: relative;
    width: 380px;
    height: 450px;
    border-radius: 8px;
    background: #F8F8F8;
    margin: 15px auto;
  }
  .piece>img{
    width: 380px;
    height: 162px;
  }
  .pieceP1 a{
    position: absolute;
    width: 340px;
    font-size: 24px;
    font-weight: 600;
    color: #ffffff;
    line-height: 48px;
    text-shadow: 0px 1px 8px rgba(0,0,0,0.4);
    margin-top: -60px;
    padding-left: 17px;

    white-space:nowrap; text-overflow:ellipsis; overflow:hidden;
    cursor:pointer;
  }
  /*.pieceP1 a:hover {*/
  /*  color: #6b6bff;*/
  /*}*/
  .pieceP2 a{

    font-size: 18px;
    color: #474747;
    line-height: 30px;
    font-weight: 400;
    padding: 36px 40px 51px 34px;
    width: 307px;
    height: 243px;

    display:-webkit-box;
    overflow:hidden;
    -webkit-line-clamp:6;
    -webkit-box-orient:vertical;
    cursor:pointer;
  }

  /*查看更多钮*/
  .piece button {
    position: absolute;
    bottom: 38px;
    right: 29px;
    padding: 0px;
    background-color: rgb(100,0,160);
    font-size: 18px;
    font-weight: 400;
    color: #FFFFFF;
  }
  .piece button{
    height: 36px;
    padding: 10px 15px 10px 14px;
    border-radius: 26px;
    border: none;
  }


  /*.pieceP2 a:hover {*/
  /*  color: #cd0000;*/
  /*}*/
  .replenish{
    height: 135px;
  }
  @media (min-width: 1001px) and (max-width: 1330px) {
    .contentPart{
      width: 820px;
    }
    .replenish{
      height: 135px;
    }
  }
  @media (min-width: 869px) and (max-width: 1000px) {
    .contentPart{
      width: 380px;
      margin: auto;
    }
  }
  @media (min-width: 580px) and (max-width: 800px) {
    /*年份开始*/
    .filter-block{
      margin: 0 auto 30px;
    }
    .van-filter > div{
      width: 33px;
      height: 26px;
      font-size: 15px;
      line-height: 29px;
      padding: 3px 21px;
    }
    /*年份结束*/
  }
  @media screen and (max-width: 580px) {
    /*年份开始*/
    .filter-block{
      margin: 0 auto 22px;
    }
    .van-filter > div{
      width: 24px;
      height: 19px;
      font-size: 11px;
      line-height: 21px;
      padding: 4px 15px;
    }
    /*年份结束*/
    .piece button {
      bottom: 19px;
      right: 15px;
      font-size: 9px;
    }
    .piece button{
      height: 20px;
      padding: 4px 8px 5px 7px;
      border-radius: 13px;
    }
  }
  @media screen and (max-width: 868px) {
    .contentPart{
      display: flex;
      align-items: center;
      width: 100%;
    }
    .contentPart > div{
      margin: 15px auto;
    }
    .piece{
      width: 67.291vw;
      height: 90.625vw;
    }
    .piece img{
      width: 67.291vw;
      height: 28.687vw;
    }
    .pieceP1 a{
      font-size: 4.604vw;
      width: 61.27vw;
      height: 6.465vw;
      margin-top: -8.298vw;
      padding-left: 3.01vw;
    }
    .pieceP2 a{
      font-size: 3.1vw;
      width: 54.364vw;
      height: 46.572vw;
      line-height: 5.3vw;
      padding: 6.197vw 6.906vw 8.854vw 6.02vw;

      display:-webkit-box;
      overflow:hidden;
      -webkit-line-clamp:6;
      -webkit-box-orient:vertical;
    }
  }
  @media screen and (max-width: 500px) {
    .pieceP1 a{
      height: 11.465vw;
      margin-top: -11.998vw;
    }
  }

  @media screen and (max-width: 500px) {
    .pieceP1 a{
      height: 11.465vw;
      margin-top: -12.998vw;
    }
  }
  .pieceP1  a:hover{
    text-decoration: underline;
  }
  .pieceP2  a:hover{
    text-decoration: underline;
  }
  @media screen and (min-width: 868px) {
    .piece button:hover .buttonUnderline {
      border-bottom: 2px solid white;
      padding-bottom: 2px;
      background-color: rgb(100,0,160);;
    }
  }

</style>



// WEBPACK FOOTER //
// src/views/web/activityInformation.vue